import script from "./CategoryStore.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryStore.vue?vue&type=script&setup=true&lang=js"

import "./CategoryStore.vue?vue&type=style&index=0&id=03702957&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03702957"]])

export default __exports__